import React from "react"
import { Flex } from "@chakra-ui/react"
import { Icon } from "../../common"

export default function MenuIcon({ icon }) {
  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      borderRadius="50%"
      bg="base.900"
      h="40px"
      w="40px"
      mr={4}
    >
      <Icon name={icon} boxSize={5} />
    </Flex>
  )
}
